<script>
	import { navigate } from "svelte-routing";
	import { Button, Label } from "sveltestrap";
	import CustomInput from "../components/CustomInput/CustomInput.svelte";
	import ErrorMessageHandler from "../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import SuccessMessageHandler from "../components/ErrorMessageHandler/SuccessMessageHandler.svelte";
	import Loader from "../components/Loader/Loader.svelte";
	import { doReset } from "../store/auth/auth";
	import { errorMessage, loading, successMessage } from "../store/store";
	let password = "";
	let confirmPassword = "";
	let err;
	let success;

	let okeToken = window.location.pathname.split("/reset-password/")[1];
	let token = okeToken?.replaceAll(" ", "");
	if (!token) {
		window.location.replace(window.location.origin + "/login");
	}
	let removeTraillingSlash = token.endsWith("/") ? token.slice(0, -1) : token;
	let testToken = removeTraillingSlash.toString();

	let img = "/assets/getgo-logo-green.png";

	errorMessage.subscribe((value) => {
		err = value;
	});

	successMessage.subscribe((value) => {
		success = value;
	});

	async function submit() {
		if (password !== confirmPassword) {
			errorMessage.set("Password and Confirm Password must match");
			return;
		} else {
			let res = doReset({ password, testToken });
		}
	}
	let load;
	loading.subscribe((value) => {
		load = value;
	});

	const handleNavigate = () => {
		errorMessage.set("");
		successMessage.set("");
		navigate("/login");
	};
</script>

<main>
	<div class="main-container">
		<div class="left">
			<div
				class="d-flex flex-column align-items-center justify-content-center w-100"
			>
				<div>
					<img
						src="/assets/getgo-logo-descriptor.png"
						alt="getgologo"
						style="width: 200px; height: 113px"
					/>
				</div>
				<div class="copyright">
					<span> Copyright © 2025. All Rights Reserved </span>
				</div>
			</div>
		</div>
		<div class="right">
			<div class="sign-in">
				<h2>Reset your password</h2>
				<ErrorMessageHandler message={err} />
				<SuccessMessageHandler message={success} />
				<div class="mt-3 mb-1">
					<Label for="password">
						<b>New Password</b>
					</Label>
				</div>
				<div>
					<CustomInput
						props={{ id: "password" }}
						type="password"
						bind:value={password}
					/>
				</div>
				<div class="mt-3 mb-1">
					<Label for="confirmPassword">
						<b>Confirm Password</b>
					</Label>
					<div />
					<div>
						<CustomInput
							props={{ id: "confirmPassword" }}
							type="password"
							bind:value={confirmPassword}
						/>
					</div>
					<div class="forgot my-4">
						<p>Do you want to login?&nbsp;&nbsp;</p>
						<a
							href="/login"
							class="link font-weight-bold"
							on:click|preventDefault={() => handleNavigate()}
							>Click here</a
						>
					</div>
					<div class="my-2">
						<Button
							block
							disabled={success}
							class="themeButton primary"
							on:click={submit}
						>
							{#if load}
								<Loader />
							{:else}
								Reset Password
							{/if}
						</Button>
					</div>
				</div>
			</div>
		</div>
	</div>
</main>
